var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgNext = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A186E",
    transform: "translate(8.7075 6.41687)",
    d: "M0.29249999 0.2937623C-0.097499996 0.68376225 -0.097499996 1.3137622 0.29249999 1.7037622L4.1725001 5.5837622L0.29249999 9.4637623C-0.097499996 9.8537626 -0.097499996 10.483763 0.29249999 10.873763C0.6825 11.263763 1.3124999 11.263763 1.7024999 10.873763L6.2925 6.283762C6.6824999 5.8937621 6.6824999 5.263762 6.2925 4.8737621L1.7024999 0.28376207C1.3224999 -0.096237928 0.6825 -0.096237689 0.29249999 0.2937623Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNext);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Next.ea41787388a603cc95cecd2e5befa745.svg";